import { axiosInstance } from './common';

export const listPlans = () =>
  axiosInstance.get('/subscription/plans').then((r) => r.data);

export const getMySubscription = () =>
  axiosInstance.get('/subscription/me').then((r) => r.data);

export const changeTier = (tier) =>
  axiosInstance.put('/subscription/me', { tier }).then((r) => r.data);

export const checkFeature = (feature) =>
  axiosInstance.get(`/subscription/features/${feature}`).then((r) => r.data);

// Admin endpoints
export const adminChangeUserTier = (userId, tier) =>
  axiosInstance.put(`/admin/subscriptions/users/${userId}`, { tier }).then((r) => r.data);

export const adminChangeOrgTier = (orgId, tier) =>
  axiosInstance.put(`/admin/subscriptions/organizations/${orgId}`, { tier }).then((r) => r.data);

export const adminGetOrgCost = (orgId) =>
  axiosInstance.get(`/admin/subscriptions/organizations/${orgId}/cost`).then((r) => r.data);
